// src/platform/core/logger.js

class Logger {
  constructor() {
    this.enabled =
      process.env.NODE_ENV !== 'production'

    this.prefix =
      '[Nexgbits Client Platform]'
  }


  /**
   * Enable or disable debug/information logging.
   */
  setEnabled(enabled) {
    this.enabled =
      Boolean(enabled)
  }


  /**
   * Change the prefix used by platform log messages.
   */
  setPrefix(prefix) {
    if (prefix) {
      this.prefix = prefix
    }
  }


  /**
   * DEBUG
   *
   * Development-oriented diagnostic messages.
   */
  debug(message, data = null) {
    if (!this.enabled) {
      return
    }

    if (data !== null) {
      console.debug(
        this.prefix,
        message,
        data
      )

      return
    }

    console.debug(
      this.prefix,
      message
    )
  }


  /**
   * INFO
   *
   * Normal platform lifecycle information.
   */
  info(message, data = null) {
    if (!this.enabled) {
      return
    }

    if (data !== null) {
      console.info(
        this.prefix,
        message,
        data
      )

      return
    }

    console.info(
      this.prefix,
      message
    )
  }


  /**
   * WARN
   *
   * Something unexpected happened but the
   * application can continue.
   */
  warn(message, data = null) {
    if (data !== null) {
      console.warn(
        this.prefix,
        message,
        data
      )

      return
    }

    console.warn(
      this.prefix,
      message
    )
  }


  /**
   * ERROR
   *
   * Platform operation failed.
   */
  error(message, data = null) {
    if (data !== null) {
      console.error(
        this.prefix,
        message,
        data
      )

      return
    }

    console.error(
      this.prefix,
      message
    )
  }


  /**
   * Generic log method.
   */
  log(message, data = null) {
    if (!this.enabled) {
      return
    }

    if (data !== null) {
      console.log(
        this.prefix,
        message,
        data
      )

      return
    }

    console.log(
      this.prefix,
      message
    )
  }
}


const logger =
  new Logger()


export default logger